import React, { useState } from "react";
import { Link } from "react-router-dom";
import "./Header.sass";
import { FaDiscord, FaTwitter } from "react-icons/fa";

export default function Header({ bg }) {
  const [visibleNav, setVisibleNav] = useState(false);
  const handleNav = () => {
    setVisibleNav(!visibleNav);
  };

  const handleCloseNav = () => {
    setVisibleNav(false);
  };

  const menu = [
    {
      title: "Discord",
      link: "https://discord.gg/onlyfrens",
    },
    {
      title: "Twitter",
      link: "https://twitter.com/OnlyFrensNFT",
    },
    {
      title: "Home",
      link: "/",
    },
    {
      title: "Story",
      link: "/story",
    },
    {
      title: "Tendies",
      link: "/tendies",
    },
    {
      title: "Halls of Amenti",
      link: "/halls-of-amenti",
    },
    {
      title: "FAQs",
      link: "/faqs",
    },
  ];
  return (
    <header
      className="header"
      style={{
        backgroundImage: `${bg}`,
        backgroundRepeat: "no-repeat",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      <div className="header-container">
        <div className="view-mobile"></div>
        <div className={`${visibleNav && "open"} header-logo`}>
          <Link to="/">
            <img src="/images/logo.png" alt="logo" />
          </Link>
        </div>
        <div className="header-nav">
          <a href="https://discord.gg/onlyfrens">
            <FaDiscord />
          </a>
          <a href="https://twitter.com/OnlyFrensNFT">
            <FaTwitter />
          </a>
          <Link to="/">Home</Link>
          <Link to="/story">Story</Link>
          <Link to="/tendies">Tendies</Link>
          <Link to="/halls-of-amenti">Halls of Amenti</Link>
          <Link to="/faqs">FAQs</Link>
        </div>
        <div
          className={`${visibleNav && "open"} hamburger`}
          onClick={() => handleNav()}
        >
          <div className={`line line-top ${!visibleNav && "open"}`} />
          <div className={`line line-middle ${!visibleNav && "open"}`} />
          <div className={`line line-bottom ${!visibleNav && "open"}`} />
        </div>
        <Menu
          visibleNav={visibleNav}
          menu={menu}
          handleCloseNav={() => handleCloseNav()}
        ></Menu>
      </div>
    </header>
  );
}

const Menu = ({ visibleNav, menu, handleCloseNav }) => {
  return (
    <div
      className={`${visibleNav && "open"} menu-container`}
      onClick={() => handleCloseNav()}
    >
      {visibleNav ? (
        <div className="menu-list">
          {menu.map((item) => {
            return (
              <div className="menu-item" key={item.title}>
                {item.title === "Twitter" || item.title === "Discord" ? (
                  <a className="menu-item" href={item.link}>
                    {item.title}
                  </a>
                ) : (
                  <Link className="menu-item" to={item.link}>
                    {item.title}
                  </Link>
                )}
                <div className="menu-line"></div>
              </div>
            );
          })}
        </div>
      ) : null}
    </div>
  );
};
